// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCampaignAccess } from '../contexts/CampaignAccessContext';
import { isUsageAdminUser } from '../utils/adminAccess';

export default function ProtectedRoute({ children, requireUsageAdmin = false }) {
  const { currentUser } = useAuth();
  const campaignAccess = useCampaignAccess();
  if (!currentUser) return <Navigate to="/login" />;
  if (requireUsageAdmin && campaignAccess.loading) return null;
  if (requireUsageAdmin && !isUsageAdminUser(campaignAccess)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
